
import {  Route, Link } from "react-router-dom"
/*
import 'style-loader!../../../css/svdreact.css'
import 'style-loader!../../../css/OrderDet.css'
*/
import Terrain from '../../terrain/Terrain'
import CardTerrain from '../../terrain/CardTerrain'

import MotelTerrain from '../../terrain/MotelTerrain'
   //import FacetBar from '../../esfind/FacetBar'
  

   import {SV_SOJ_ORCMOCK_ADDRESS} from '../../../constants'
   import { Icon, Button as SVAButton, Row, Col, Badge } from 'antd';

//import TerrainLocationListView from '../../terrain/TerrainLocationListView'

import ErrorCom from '../../core/AbodeErrorTag'
import SVAbodeSpinner from '../../core/SVAbodeSpinner'

import '../../../css/svdreact.css'
import '../../../css/OrderDet.css'
   const React = require('react')
   const _ = require('lodash')

  // const {connect}  = require("react-redux")


   

   const HeartSvg = () => (
    <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
      <path d="M923 283.6c-13.4-31.1-32.6-58.9-56.9-82.8-24.3-23.8-52.5-42.4-84-55.5-32.5-13.5-66.9-20.3-102.4-20.3-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5-24.4 23.9-43.5 51.7-56.9 82.8-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3 0.1-35.3-7-69.6-20.9-101.9z" />
    </svg>
  );

   const HeartIcon = props => <Icon component={HeartSvg} {...props} />;

  class Storedcards extends React.Component {

    constructor(props){
        super(props)
        let me = this
        this.getAppDetails = this.getAppDetails.bind(me)
        this.getAppDetailsMyReservation = this.getAppDetailsMyReservation.bind(me)
        this.getChildContainersTerrain = this.getChildContainersTerrain.bind(me)
        this.getChildContainersDetail = this.getChildContainersDetail.bind(me)
        this.getCrdContainer = this.getCrdContainer.bind(me)
        this.deleteTaskCurryParams  = this.deleteTaskCurryParams.bind(me)

  
    }
    deleteTaskCurryParams = (param1, ctx)=>(event)=>{
		let me = ctx
		me.currentSelection = param1
		console.log('sv delete task curry')
		console.log(param1)
		me.props.svWrappedDeleteAddressActionCreator(param1.id)
	}
    getAppDetailsMyReservation(paramQSpaceId, svcustProfile, svtv){
        console.log('caall getAppDetailsMyReservation', paramQSpaceId,svcustProfile)
        this.props.loadStoredcardListMyReservationForCustIdSecure(paramQSpaceId, svcustProfile, svtv)
        //this.props.sojDetailsAndImagesSV("mancreek") 
        /*this.props.getSojournDetails("mancreek") */
       
    }
    getAppDetails(paramQSpaceId){
        console.log('order detail confirmationcode**************', paramQSpaceId)
        this.props.loadStoredcardList(paramQSpaceId)
        // this.props.getSoDetails("mancreek")
 
       // this.props.ordAndImagesSV()
        
     }

     componentWillMount()	{
        console.log('sv--addresses=--- link sends us params')
        console.log(this.props.svparams)
        const {dataProfile, svcustProfile, custProfile} = this.props
        console.log('sv--dara profie from HOC+')
       console.log(dataProfile)
       console.log('sv--dara svcustProfile from HOC+')
       console.log(svcustProfile)
       
      // let custProfile = svcustProfile

         //console.log(this.props.svparams.id)
         let id = 2;
         if(this.props.svparams){
            id = this.props.svparams.id
         
         }else{
          console.log('not called by router')
          id = 1;
         }
        
    console.log('sbv--addressed for customer id ****+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:'+ id)
    
    const { cookies } = this.props;
    if(svcustProfile && svcustProfile.customerId > 0){
        this.getAppDetailsMyReservation(id,svcustProfile  ,cookies.get('svt'))
       }else{
        this.getAppDetails(id)
       }
    
      
       // this.props.priceAndTexNow(id);
   
			
			
	

	}

     render() {
        const lastestUpdateDate = 'Data Refresh Daily'
       console.log('sv1 render***')

        return (

            
            <div className="col-md-12">

                <MotelTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getChildContainersTerrain()}></MotelTerrain>
            </div>
        )

    }

    getCrdContainer(rev, svCustomerId){

        return  (
            <div className="rev-row">
            <div className="card card--raised with-shadow">
           
            <p className="right-sd-content"> <span  >	<Link to={`/myaccountSV/${svCustomerId}/svstoredcard/${rev.id ?rev.id :5}`}> <Icon  style={{ color: '#eeb838' }} type="edit" theme="filled" /> <text> {rev.fname ?rev.fname :'Allen' } {rev.lname ?rev.lname :'Bode' }  </text></Link></span><span  onClick={  this.deleteTaskCurryParams(rev, this)}><Icon  style={{ color: '#e30b29' }} type="delete" theme="filled" /></span></p>
                
               <p className="sd-check"> <text> Name As Appears On Card :  {rev.name ?rev.name :'Missing' } </text></p>
                <p className="sd-check"> <text> Card Number:  {rev.cardNumber ?rev.cardNumber :'408-1234-4123' } </text></p>
                <p className="sd-check"> <text> Card CVV:  {rev.cardCvv ?rev.cardCvv :'408-1234-4123' } </text></p>
                <p className="sd-check"> <text> Card Expiry Month:  {rev.cardExpMonth ?rev.cardExpMonth :'01' } </text></p>
                <p className="sd-check"> <text> Card Expiry Year:  {rev.cardExpYear ?rev.cardExpYear :'33' } </text></p>
                <p className="sd-check"> <text> Billing Address : {rev.address ?rev.address :'12 Scotland ave' }</text></p>
                <p className="sd-check"> <text> Billing Zip Code:  {rev.zip ? ( rev.zip + ' ' +rev.zip ):'95111' }</text></p>
                <p className="sd-check"> <text> Billing Country(3Letter Code):  {rev.country ?rev.country :'US' }</text></p>

                <p className="sd-check"> <text> Card Is Valid:  {rev.isValid ?rev.isValid :'Y' } </text></p>
                <p className="sd-check"> <text> Card Can Be Deleted?:  {rev.cardDelete ?rev.cardDelete :'Y' } </text></p>
                <p className="sd-check"> <text> Card Block:  {rev.cardBlock ?rev.cardBlock :'N' } </text></p>

                <p className="sd-check"> <text> Phone:  {rev.phone ?rev.phone :'408-1234-4123' } </text></p>
                <p className="sd-check"> <text> Isd Code:  {rev.isdcode ?rev.isdcode :'1' } </text></p>
                <p className="sd-check"> <text> Email: {rev.email ?rev.email :'allen@yahoo.com' }</text></p>
               
               
               

</div>
</div>

        )

    }

    getChildContainersTerrain() {
        console.log('sv1 render*** 2')
        let svCustomerId = -1
        console.log('sv***storedcard needs **svcustProfile')
        console.log(this.props)
        
        if(this.props.svcustProfile && this.props.svcustProfile.customerId > 0){
            svCustomerId = this.props.svcustProfile.customerId 
           }else{
            console.log('**8address create and detail has no customerid')
           }

        return (
            <div className="svr-det-pageWrapper">
               <header className="svr-header1">
                    <h1><span><text style={{color:'#f0d8a9'}}>Customer Storedcards Information </text><Link to={`/myaccountSV/${svCustomerId}/svstoredcard/-1`}> <Icon  style={{ color: '#eeb838' }} type="plus-square" theme="filled" /> </Link><Link to={`/myaccountSV/${svCustomerId}/svprofile`}> <Icon  style={{ color: '#eeb838' }} type="home" theme="filled" /> </Link></span> </h1>
                </header>
              
                {this.getChildContainersDetail()}
             
           </div>   
             )   
      }
    getChildContainersDetail() {
        const lastestUpdateDate = 'Data Refresh Daily'
        const { title} = this
        let soj = null, data = [], hosts = [], dbs = [], sojourns = [] ,my_data = []

        //svaddresslistView
        let my_data_review ={
            "Request": {
                "checkin": "OK",
                "stay": "6",
                "stayInit": "nights",
                "checkout": "UU12345",
                "checkinTime": "Sat, Sept 9, 3027",
                "checkinTimePrefix": "From 3:00 PM",
                "checkoutTimePrefix": "Until 11:00 AM",
                "checkoutTime": "Sat, Sept 16, 3027"
            },
            "spaceDet": {
            
                "space_details": "Queen Room with Two Queen Beds",
                "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                "cancellation": "Free cancellation before December 9, 2024 ",
                "guests": "2 adults ",
                "cleaniness_score" : "7.7",
                "non_smoking":true,
        
                "space_amenity_name": [
                    "300 feet elevator",
                    "air conditioning",
                    "private bathroom"
                ]
               
               
            },
            "booking": {
                "resort_name": "Cambria Hotel Orlando Airport",
                "propertyAddress": "6825 Visitor Circle, Orlando, FL 32891, USA",
                "stayDet": "6 nights",
                "num_reviews": 101,
                "amenity_name": [
                    "HotTub",
                    "Spa",
                    "Swimming pool",
                    "Laundry"
                ],
                "num_reviews_label": "Good, ",
                "rating_detail":" Excellebt, 9.1",
                "num_reviews_detail": "Good, 101 reviews"
               
            },
            "price": {
                "total": "$923",
                "depositValue":"$200.26",
                "depositName":"Damage Deposit (Fully refundable)",
                "currency": "usd",
                "tax": {
                   
                    "taxTotal": "$102.34",
                    "maintax": "$49.08",
                    "citytax": "$53.26",
        
                    "taxPercent": "6",
                    "citytaxPercent": "6.5"
                }
            },
            "id": "addLeft_step",
            "gene": "addLeft_step",
            "dcountry": "China",
            "privateparking":false,
            "rentcar":false,
            "bookTaxi":false,
            "needFlight":false,
            "arrivalTimeZone":"tz_pst",
            "fname": "John",
            "lname": "Glen",
            "email": "john123@yahoo.com",
            "address": "12 scotland av",
            "city": "Albany",
            "state": "New York",
            "zip": "12110",
            "country": "USA",
            "isdcode": "+1",
            "phone": "5121234356",
            "bookingAgentType": "self",
            "traveType": "Personal",
            "specialRequests": "Wheel chair and Senior Citizen",
            "gname": "Glen",
            "gemail": "Glen@yahoo.com",
            "card": "1234-1234--1234--1234",
            "cvv": "Glen",
            "mmexp": "04",
            "yyyyexp": "2028"
        }

        let my_data_storedcardlist = [
            {
                "cardId": 3,
                "customerId": 3,
                "paymentMethodCode": "card",
                "paymentType": "self",
                "productDetails": "svr",
                "description": "my hw default",
                "cardNumber": "5123412341234123",
                "cardCvv": "111",
                "cardExpMonth": "01",
                "cardExpYear": "31",
                "email": "alen@br.com",
                "isValid": "Y",
                "cardDelete": "N",
                "cardBlock": "N",
                "createdDate": "2024-08-05T04:00:00.000+0000",
                "modifiedDate": "2024-08-05T04:00:00.000+0000",
                "createdBy": "AbodeSystemAdmin",
                "modifiedBy": "AbodeSystemAdmin",
                "name": null,
                "fname": null,
                "lname": null,
                "phone": null,
                "address": null,
                "zip": null,
                "isdcode": null
            }
        ]
        if (this.props.my_data_storedcardlist ) {
            my_data_storedcardlist = this.props.my_data_storedcardlist
          
          
        }
        let svCustomerId = -1
        console.log('sv***storedcard needs **svcustProfile')
        console.log(this.props)
        
        if(this.props.svcustProfile && this.props.svcustProfile.customerId > 0){
            svCustomerId = this.props.svcustProfile.customerId 
           }else{
            console.log('**8address create and detail has no customerid')
           }
           if(this.props.error && this.props.errob){
            console.log('sv**container ger errob')
            console.log(this.props)
           return (
             <div >
                
                 <div style={{paddingTop:'10px'}}>
                   <ErrorCom  errob={this.props.errob} ></ErrorCom>
                 </div>
                 <div style={{paddingTop:'10px'}}>
                     <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/svlogin`}> My Reservations   </Link></SVAButton>
                 </div>
                
              </div>   
                )
   
          }else if(this.props.loading ){
           return (
   
            <div >
            <h3>Spinner*****</h3>
           <div style={{paddingTop:'10px'}}>

           <SVAbodeSpinner />
           </div>
   
        </div>   
   
           
                 )
   
          }else {
        return (

            
                <div className="svr-gal-contentWrapper">
                    <article className="main">
                    {
                            my_data_storedcardlist.map(o => {
                                let soj = o
                                //convet keys of o to uppercase
                                console.log('sv***soj**')
                                console.log(soj)
                                

                                return (
                                    <CardTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getCrdContainer(o,svCustomerId)}></CardTerrain>
                                    
                                )
                            })
                        }
                        
                    </article>
                </div>
           
        )
                    }

    }


  }

  export default Storedcards